export default function GlobalStyles({ t }) {
  return (
    <style>{`
      html, body {
        margin: 0;
        padding: 0;
        background: ${t.bg};
        min-height: 100%;
      }

      body {
        -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
      }

      .alex-root * { box-sizing: border-box; }
      .alex-root {
        font-family: 'Source Serif 4', Georgia, serif;
        font-weight: 300;
        letter-spacing: 0;
      }

      .alex-root ::selection {
        background: ${t.selectionBg};
        color: ${t.text};
      }

      .alex-root a,
      .alex-root button,
      .alex-root select {
        transition: color 0.15s ease, border-color 0.15s ease, background-color 0.15s ease;
      }

      .alex-root a:hover,
      .alex-root button:hover {
        color: ${t.linkHover} !important;
      }

      .alex-root a:focus-visible,
      .alex-root button:focus-visible,
      .alex-root select:focus-visible,
      .alex-root input:focus-visible {
        outline: 2px solid ${t.link};
        outline-offset: 3px;
      }

      .site-search {
        margin-top: 22px;
      }

      .site-search-trigger:hover {
        border-color: ${t.link} !important;
        color: ${t.text} !important;
      }

      .pre-code {
        background: ${t.surface};
        border: 1px solid ${t.border};
        border-left: 3px solid #3a3a3a;
        padding: 20px;
        overflow-x: auto;
        font-family: 'JetBrains Mono', monospace;
        font-size: 13px;
        line-height: 1.65;
        color: ${t.muted};
        margin: 0;
      }
      .kw  { color: #c792ea; }
      .fn  { color: #82aaff; }
      .str { color: #c3e88d; }
      .cm  { color: #4a4a4a; font-style: italic; }
      .num { color: #f78c6c; }
      .type { color: #ffcb6b; }

      .post-row {
        border-radius: 8px;
        margin-left: -10px;
        margin-right: -10px;
        padding-left: 10px !important;
        padding-right: 10px !important;
        transition: background-color 0.15s ease;
      }

      .post-row:hover {
        background: ${t.rowHover};
      }

      .post-row:hover .post-row-title { color: ${t.link}; }

      .reading-progress {
        height: 3px;
        left: 0;
        position: fixed;
        top: 0;
        transform-origin: 0 50%;
        transition: transform 0.08s linear;
        width: 100%;
        z-index: 10000;
      }

      .code-wrapper {
        margin: 20px 0;
      }

      .code-title {
        color: ${t.dim};
        font-family: 'JetBrains Mono', monospace;
        font-size: 12px;
      }

      .code-toolbar {
        align-items: center;
        display: flex;
        gap: 12px;
        justify-content: space-between;
        margin-bottom: 8px;
      }

      .code-copy-button {
        background: transparent;
        border: 0;
        cursor: pointer;
        font-family: 'JetBrains Mono', monospace;
        font-size: 12px;
        padding: 0;
      }

      .image-carousel {
        position: relative;
        overflow: hidden;
        border-radius: 8px;
        box-shadow: ${t.shadow};
      }

      .image-carousel-track {
        display: flex;
        transition: transform 0.24s ease;
        will-change: transform;
      }

      .image-carousel-slide {
        align-items: center;
        display: flex;
        flex: 0 0 100%;
        justify-content: center;
        min-height: 220px;
        padding: 12px;
      }

      .image-carousel-slide img {
        border-radius: 6px;
        display: block;
        object-fit: contain;
      }

      .image-carousel-button {
        align-items: center;
        border-radius: 999px;
        cursor: pointer;
        display: flex;
        font-family: 'JetBrains Mono', monospace;
        font-size: 16px;
        height: 34px;
        justify-content: center;
        line-height: 1;
        opacity: 0.88;
        padding: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 34px;
      }

      .image-carousel-button:hover {
        opacity: 1;
      }

      .image-carousel-button-left {
        left: 12px;
      }

      .image-carousel-button-right {
        right: 12px;
      }

      .image-carousel-meta {
        display: flex;
        font-family: 'JetBrains Mono', monospace;
        font-size: 12px;
        justify-content: space-between;
        gap: 12px;
        margin-top: 8px;
      }

      .image-carousel-dots {
        display: flex;
        gap: 6px;
        justify-content: center;
        margin-top: 10px;
      }

      .image-carousel-dots button {
        border: 0;
        border-radius: 999px;
        cursor: pointer;
        height: 7px;
        padding: 0;
        width: 7px;
      }

      input:focus, textarea:focus {
        border-color: ${t.link} !important;
        background: ${t.surface} !important;
        outline: none;
      }

      input:-webkit-autofill,
      input:-webkit-autofill:hover,
      input:-webkit-autofill:focus {
        -webkit-box-shadow: 0 0 0px 1000px ${t.surface2} inset;
        -webkit-text-fill-color: ${t.text};
      }

      .search-overlay {
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.4);
        backdrop-filter: blur(6px);
        display: flex;
        justify-content: center;
        align-items: flex-start;
        padding: 10vh 16px 0;
        z-index: 9999;
        animation: fadeIn 0.15s ease;
      }

      .search-modal {
        width: 100%;
        max-width: 640px;
        background: ${t.surface};
        border: 1px solid ${t.border};
        border-radius: 8px;
        box-shadow: ${t.shadow};
        overflow: hidden;
        animation: slideDown 0.18s ease;
      }

      .search-modal input {
        width: 100%;
        padding: 20px;
        font-size: 18px;
        border: none;
        outline: none;
        background: ${t.surface2};
        color: ${t.text};
      }

      .search-modal input:focus,
      .search-modal input:focus-visible {
        outline: none;
        border: none !important;
      }

      .search-modal input::-webkit-search-cancel-button {
        cursor: pointer;
      }

      .search-input-wrap {
        align-items: center;
        background: ${t.surface2};
        border-bottom: 1px solid ${t.border};
        display: flex;
      }

      .search-results {
        max-height: 400px;
        overflow-y: auto;
      }

      .search-item {
        padding: 16px 20px;
        cursor: pointer;
        transition: background 0.15s ease;
      }

      .search-item:hover {
        background: ${t.surface2};
      }

      .search-empty {
        font-family: 'JetBrains Mono', monospace;
        font-size: 13px;
        padding: 18px 20px;
      }

      @media (max-width: 560px) {
        .alex-root {
          font-size: 15px;
        }

        .search-overlay {
          padding-top: 7vh;
        }

        .search-modal input {
          font-size: 16px;
          padding: 16px;
        }

        .image-carousel-slide {
          min-height: 160px;
          padding: 8px;
        }

        .image-carousel-button {
          height: 30px;
          width: 30px;
        }
      }

      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }

      @keyframes slideDown {
        from { transform: translateY(-10px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
    `}</style>
  );
}
